module.exports = __webpack_public_path__ + "img/toyohashi_hc.540c162c.jpg";